var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 sm:mt-6 px-0 py-5 flex flex-col items-center justify-center relative"},[_c('div',{staticClass:"h-fit flex items-center justify-center space-x-0"},[_c('vue-apex-charts',{staticClass:"w-full",attrs:{"type":"pie","options":_vm.options,"series":_vm.series,"animations":_vm.animations}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }